<template>
	<div class="upload-file">
		<!--        pdffileList-&#45;&#45;{{ fileList }}-->
		<el-upload
			multiple
			name="fileName"
			:action="uploadFileUrl"
			:before-upload="handleBeforeUpload"
			:file-list="fileList"
			:limit="limit"
			:on-error="handleUploadError"
			:on-exceed="handleExceed"
			:on-success="handleUploadSuccess"
			:show-file-list="false"
			:headers="headers"
			class="upload-file-uploader"
			ref="fileUpload"
		>
			<!-- 上传按钮 -->
			<el-button plain type="primary" class="el-button--mini-h"><i class="el-icon-upload"></i>选取文件</el-button>
		</el-upload>
		<!-- 上传提示 -->
		<div class="el-upload__tip" v-if="showTip">
			<template v-if="fileSize">
				文件大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>；
			</template>
			<!-- </br> -->
			<template v-if="fileType">
				格式为 <b style="color: #f56c6c">{{ fileType.join('，') }}</b>
			</template>
			的文件
		</div>
		<!-- 文件列表 -->
		<!-- {{ fileList }} -->
		<transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul" style="display: flex; flex-wrap: wrap">
			<li class="el-upload-list__item ele-upload-list__item-content" v-for="(file, index) in fileList" :key="index">
				<!-- <el-link :href="file.url" :underline="false" target="_blank">
					<span class="el-icon-document">
						{{ file.name }}
					</span>
				</el-link>
				<div class="ele-upload-list__item-content-action">
					<el-link :underline="false" @click="handlePreview(file.url)" type="primary" style="margin-left: 30px">预览</el-link>
					<el-link :underline="false" @click="handleDelete(index)" type="danger" style="margin-left: 6px">删除</el-link>
				</div> -->

				<img class="el-upload-list__item-thumbnail" :src="file.showUrl" alt="" style="background-size: auto; max-width: 100%; max-height: 100%" />
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePreview(file.url)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<!-- <span  class="el-upload-list__item-delete" @click="handleDownload(file)">
						<i class="el-icon-download"></i>
					</span> -->
					<span class="el-upload-list__item-delete-btn" @click="handleDelete(index)">
						<i class="el-icon-delete"></i>
					</span>
				</span>
			</li>
		</transition-group>
	</div>
</template>

<script>
import User from '@/utils/User.js';
import { getFilesInfo } from '@/api/file/file.js';

export default {
	name: 'UploadImageList',
	props: {
		modelValue: [String, Object, Array],
		// 数量限制
		limit: {
			type: Number,
			default: 1
		},
		// 大小限制(MB)
		fileSize: {
			type: Number,
			default: 100
		},
		// 文件类型, 例如['png', 'jpg', 'jpeg']
		fileType: {
			type: Array,
			default: () => ['pdf']
		},
		// 是否显示提示
		isShowTip: {
			type: Boolean,
			default: true
		},
		// 文件列表--回显
		editFileList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			number: 0,
			uploadFileUrl: '/webL_api/third/files/uploadFile', // 上传的文件服务器地址
			uploadParams: {},
			uploadFileList: [],
			headers: { Authorization: 'Bearer ' + User.getToken() },
			fileList: []
		};
	},

	computed: {
		showTip() {
			return this.isShowTip && (this.fileType || this.fileSize);
		}
	},

	watch: {
		modelValue: {
			handler(val) {
				if (val) {
					let temp = 1;
					// 首先将值转为数组
					const list = Array.isArray(val) ? val : this.modelValue.split(',');
					// 然后将数组转为对象数组
					this.fileList = list.map(item => {
						if (typeof item === 'string') {
							item = { name: item, url: item };
						}
						item.uid = item.uid || new Date().getTime() + temp++;
						return item;
					});
				} else {
					this.fileList = [];
					return [];
				}
			},
			deep: true,
			immediate: true
		},

		editFileList: {
			handler(val) {
				if (val === null) {
					this.fileList = [];
				} else {
					if (val.length) {
						this.fileList = val;
					}
				}
			},
			deep: true
		}
	},

	methods: {
		// 上传前校检格式和大小
		handleBeforeUpload(file) {
			// 校检文件类型
			if (this.fileType.length) {
				const fileName = file.name.split('.');
				const fileExt = fileName[fileName.length - 1];
				// 处理带点的文件类型（如 .pdf）
				const fileExtensions = this.fileType.map(type => (type.startsWith('.') ? type.substring(1) : type));
				const isTypeOk = fileExtensions.indexOf(fileExt) >= 0;
				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join('，')}格式文件!`);
					return false;
				}
			}
			// 校检文件大小
			if (this.fileSize) {
				const isLt = file.size / 1024 / 1024 < this.fileSize;
				if (!isLt) {
					this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
					return false;
				}
			}
			// 校检文件数量限制
			if (this.fileList.length >= this.limit) {
				this.$message.error(`最多只能上传 ${this.limit} 个文件!`);
				return false;
			}

			return true;
		},

		// 文件个数超出
		handleExceed() {
			this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
		},

		// 上传失败
		handleUploadError(err) {
			this.$message.error('上传文件失败');
		},

		// 上传成功回调
		async handleUploadSuccess(res, file) {
			console.log('Success', res, file);

			// 如果上传成功
			if (res.code == 200) {
				// console.log('上传成功', res.data);
				let fileUrl = res.data;

				// 获取展示的图片URL
				try {
					const showFileUrl = await this.getFileShowUrl(fileUrl);
					// console.log('showFileUrl', showFileUrl);

					// 创建新的文件对象并添加到列表
					const newFile = {
						name: file.name,
						url: fileUrl,
						uid: file.uid,
						showUrl: showFileUrl
					};

					// 添加到文件列表
					this.fileList.push(newFile);

					// console.log('fileList', this.fileList);
					// console.log('fileUrl', this.listToString(this.fileList));

					// 触发更新事件
					this.$emit('update:modelValue', this.listToString(this.fileList));
					this.$emit('change', this.listToString(this.fileList));
					// this.$message.success('文件上传成功');
				} catch (error) {
					console.error('获取文件展示URL失败:', error);
					// 即使获取展示URL失败，也创建文件对象，但使用默认URL
					const newFile = {
						name: file.name,
						url: fileUrl,
						uid: file.uid,
						showUrl: fileUrl // 使用原始URL作为备选
					};
					this.fileList.push(newFile);
					this.$emit('update:modelValue', this.listToString(this.fileList));
					this.$emit('change', this.listToString(this.fileList));
					// this.$message.success('文件上传成功，但预览功能可能受限');
				}
			} else {
				this.$message.error('文件上传失败');
			}
		},

		// 删除文件
		handleDelete(index) {
			// 删除指定索引的文件
			this.fileList.splice(index, 1);
			this.$emit('update:modelValue', this.listToString(this.fileList));
			this.$emit('change', this.listToString(this.fileList));
			// this.$message.success('文件删除成功');
		},

		//预览
		async handlePreview(url) {
			// 获取文件详情
			try {
				const prefix = '/third/files/info/';
				const key = url.replace(prefix, '');
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const urlData = URL.createObjectURL(blob);
				window.open(urlData);
			} catch (error) {
				console.error('获取文件失败:', error);
				return null;
			}
		},

		//获取展示的图片
		async getFileShowUrl(url) {
			// 获取文件详情
			try {
				const prefix = '/third/files/info/';
				const key = url.replace(prefix, '');
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const urlData = URL.createObjectURL(blob);
				return urlData;
			} catch (error) {
				console.error('获取文件失败:', error);
				return null;
			}
		},

		// 上传结束处理
		uploadedSuccessfully() {
			// console.log('Successfully', this.fileList);
			if (this.fileList.length >= 2) {
				this.fileList.splice(0, 1);
			}
			this.$emit('update:modelValue', this.listToString(this.fileList));
			this.$modal.closeLoading();
		},

		// 对象转成指定字符串分隔
		listToString(list, separator) {
			let strs = '';
			separator = separator || ',';
			for (let i in list) {
				if (list[i].url) {
					strs += list[i].url + separator;
				}
			}
			return strs != '' ? strs.substr(0, strs.length - 1) : '';
		},

		//获取fileList
		getFileList() {
			return this.fileList;
		},

		//获取fileList
		clearFileList() {
			this.fileList = [];
		}
	}
};
</script>

<style scoped lang="less">
.upload-file-uploader {
	margin-bottom: 10px;
}
.upload-file-list .el-upload-list__item {
	overflow: hidden;
	background-color: #fff;
	border: 1px solid #c0ccda;
	border-radius: 6px;
	box-sizing: border-box;
	width: 148px;
	height: 148px;
	margin: 0 8px 8px 0;
	display: inline-block;

	display: flex;
	align-items: center;
	justify-content: center;

	// &:hover {
	// 	background-color: #f0f2f5;
	// 	border-color: #c0c4cc;
	// }
}
.upload-file-list .ele-upload-list__item-content {
	display: flex;
	align-items: center;
	// justify-content: space-between;
	color: inherit;
	font-size: 14px;
}
.ele-upload-list__item-content-action .el-link {
	margin-right: 10px;
	font-size: 13px;
}
.el-upload__tip {
	color: #909399;
	font-size: 12px;
	line-height: 1.5;
	margin-top: 5px;
}

.el-upload-list__item-actions {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	cursor: default;
	text-align: center;
	color: #fff;
	opacity: 0;
	font-size: 20px;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s;

	span {
		cursor: pointer;
	}

	span:first-child {
		display: block;
		margin-top: 20px;
		line-height: auto;
	}

	span:last-child {
		margin-top: 12px;
		line-height: auto;
	}
}

.el-upload-list__item-actions:hover {
	opacity: 1;
}
</style>
